<template>
  <div class="contentBox">
    <!-- 个人信息多重旋转背景水印（完全复用 pdf/index.vue 样式） -->
    <div class="contentBoxText" style="top: -300px">
      <div class="contentItem">
        <span>{{ pdfText }}</span> <span>{{ pdfText }}</span>
      </div>
    </div>
    <div class="contentBoxText" style="top: 0px">
      <div class="contentItem">
        <span>{{ pdfText }}</span> <span>{{ pdfText }}</span>
      </div>
    </div>
    <div class="contentBoxText" style="top: 300px">
      <div class="contentItem">
        <span>{{ pdfText }}</span> <span>{{ pdfText }}</span>
      </div>
    </div>
    <div class="contentBoxText" style="top: 600px">
      <div class="contentItem">
        <span>{{ pdfText }}</span> <span>{{ pdfText }}</span>
      </div>
    </div>
    <div class="contentBoxText" style="top: 900px">
      <div class="contentItem">
        <span>{{ pdfText }}</span> <span>{{ pdfText }}</span>
      </div>
    </div>

    <!-- 主体文件在线预览渲染区域 -->
    <div class="preview-body" v-loading="loading">
      <!-- 1. PDF 文件格式渲染 (VueOfficePdf 插件渲染) -->
      <template v-if="fileType === 'pdf'">
        <VueOfficePdf
          style="width: 100%; height: calc(100vh - 120px)"
          :src="pdfUrl"
          @rendered="renderedHandler"
          @error="errorHandler"
        />
      </template>

      <!-- 2. DOCX 格式在线渲染容器 (@js-preview/docx) -->
      <div
        v-show="fileType === 'docx'"
        ref="docxContainer"
        class="office-render-container"
      ></div>

      <!-- 3. EXCEL 格式在线渲染容器 (@js-preview/excel) -->
      <div
        v-show="fileType === 'excel'"
        ref="excelContainer"
        class="office-render-container"
      ></div>

      <!-- 4. 图片格式渲染 -->
      <template v-if="fileType === 'image'">
        <div class="image-preview-wrap">
          <img :src="pdfUrl" class="preview-img" alt="预览图片" />
        </div>
      </template>

      <!-- 5. 纯文本/Iframe通用嵌入预览 -->
      <template v-if="fileType === 'txt' || fileType === 'iframe'">
        <iframe :src="pdfUrl" class="preview-iframe" frameborder="0"></iframe>
      </template>

      <!-- 6. 其他暂无法直接网页渲染的格式/加载失败兜底提示 -->
      <template v-if="fileType === 'other' || loadError">
        <div class="fallback-preview-wrap">
          <i class="el-icon-document-checked fallback-icon"></i>
          <h3 class="fallback-title">{{ pdfName || "附件文档" }}</h3>
          <p class="fallback-desc">
            该文件类型暂不支持在网页中直接渲染，请点击下方按钮下载后查看。
          </p>
          <el-button type="primary" icon="el-icon-download" @click="downPdf">
            立即下载文件到本地
          </el-button>
        </div>
      </template>
    </div>

    <!-- 底部固定控制栏（与 pdf/index.vue 保持完全一致） -->
    <div class="btmBox">
      <div class="return" @click="returnFun">返回上一页</div>
      <div class="btn" @click="downPdf">立即下载</div>
    </div>
  </div>
</template>

<script>
import VueOfficePdf from "@vue-office/pdf";
import jsPreviewDocx from "@js-preview/docx";
import "@js-preview/docx/lib/index.css";
import jsPreviewExcel from "@js-preview/excel";
import "@js-preview/excel/lib/index.css";
import { userDetail } from "@/api/lx";

export default {
  name: "SchoolFilePreview",
  components: {
    VueOfficePdf,
  },
  data() {
    return {
      // 当前预览文件链接
      pdfUrl: "",
      // 当前预览文件名
      pdfName: "",
      // 背景个人信息水印内容
      pdfText: "良信电器",
      // 文件识别类型: pdf | docx | excel | image | txt | iframe | other
      fileType: "pdf",
      // 加载中遮罩
      loading: false,
      // 加载异常标识
      loadError: false,
      // @js-preview 句柄
      docxPreviewer: null,
      excelPreviewer: null,
    };
  },
  created() {
    // 提取路由传入的文件地址与名称
    this.pdfUrl = this.$route.query.url || "";
    this.pdfName = this.$route.query.name || "";
    console.log("新页面预览文件 URL:", this.pdfUrl);
    console.log("新页面预览文件 名称:", this.pdfName);

    // 解析文件类型后缀
    this.parseFileType();

    // 获取当前登录用户生成全局水印
    this.getUser();
  },
  mounted() {
    // 渲染 DOM 完成后初始化 Word 与 Excel 在线预览
    this.$nextTick(() => {
      setTimeout(() => {
        this.initOfficePreview();
      }, 100);
    });
  },
  beforeDestroy() {
    // 离开页面时注销渲染器
    this.destroyPreviewers();
  },
  methods: {
    /**
     * 根据文件名或 URL 的拓展名判断文件类型
     * @returns {void}
     */
    parseFileType() {
      if (!this.pdfUrl) {
        this.fileType = "other";
        return;
      }
      const cleanName = (this.pdfName || this.pdfUrl).split("?")[0];
      const parts = cleanName.split(".");
      const ext = parts.length > 1 ? parts.pop().toLowerCase() : "";

      if (ext === "pdf") {
        this.fileType = "pdf";
      } else if (["docx"].includes(ext)) {
        this.fileType = "docx";
      } else if (["xlsx", "xls", "csv"].includes(ext)) {
        this.fileType = "excel";
      } else if (["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(ext)) {
        this.fileType = "image";
      } else if (["txt", "json", "md"].includes(ext)) {
        this.fileType = "txt";
      } else {
        this.fileType = "other";
      }
    },

    /**
     * 获取用户信息，拼接页面水印（包含姓名、岗位、公司、手机号）
     * @returns {void}
     */
    getUser() {
      userDetail({})
        .then((res) => {
          if (res && res.data) {
            this.pdfText = `${res.data.username || ""}(${res.data.post || ""})${
              res.data.companyName ? `@${res.data.companyName}` : ""
            } ${res.data.phone || ""}`;
          }
        })
        .catch((err) => {
          console.error("获取水印用户信息失败:", err);
        });
    },

    /**
     * 初始化 DOCX 及 Excel 的 jsPreview 组件
     * @returns {void}
     */
    initOfficePreview() {
      if (!this.pdfUrl) return;

      if (this.fileType === "docx" && this.$refs.docxContainer) {
        this.loading = true;
        this.destroyPreviewers();
        try {
          this.docxPreviewer = jsPreviewDocx.init(this.$refs.docxContainer);
          this.docxPreviewer
            .preview(this.pdfUrl)
            .then(() => {
              this.loading = false;
              this.$nextTick(() => {
                window.dispatchEvent(new Event("resize"));
              });
            })
            .catch((err) => {
              console.error("DOCX 文件预览失败:", err);
              this.loading = false;
              this.loadError = true;
            });
        } catch (e) {
          console.error("初始化 Word 预览失败:", e);
          this.loading = false;
          this.loadError = true;
        }
      } else if (this.fileType === "excel" && this.$refs.excelContainer) {
        this.loading = true;
        this.destroyPreviewers();
        try {
          this.excelPreviewer = jsPreviewExcel.init(this.$refs.excelContainer);
          this.excelPreviewer
            .preview(this.pdfUrl)
            .then(() => {
              this.loading = false;
              // 触发 resize 事件促使表格画布与工作区重新计算精准高度
              this.$nextTick(() => {
                window.dispatchEvent(new Event("resize"));
              });
            })
            .catch((err) => {
              console.error("Excel 文件预览失败:", err);
              this.loading = false;
              this.loadError = true;
            });
        } catch (e) {
          console.error("初始化 Excel 预览失败:", e);
          this.loading = false;
          this.loadError = true;
        }
      }
    },

    /**
     * 销毁办公文档渲染器句柄，防止内存泄露
     * @returns {void}
     */
    destroyPreviewers() {
      if (this.docxPreviewer) {
        try {
          this.docxPreviewer.destroy();
        } catch (e) {}
        this.docxPreviewer = null;
      }
      if (this.excelPreviewer) {
        try {
          this.excelPreviewer.destroy();
        } catch (e) {}
        this.excelPreviewer = null;
      }
    },

    /**
     * PDF 渲染完成成功回调函数
     * @returns {void}
     */
    renderedHandler() {
      console.log("PDF 渲染成功");
      this.loading = false;
    },

    /**
     * PDF 渲染异常失败回调函数
     * @returns {void}
     */
    errorHandler() {
      console.log("PDF 渲染失败");
      this.loading = false;
      this.loadError = true;
    },

    /**
     * 返回上一页按钮事件处理
     * @returns {void}
     */
    returnFun() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        window.close();
      }
    },

    /**
     * 点击立即下载文件到本地
     * @returns {void}
     */
    downPdf() {
      if (!this.pdfUrl) {
        this.$message.warning("暂无文件下载链接");
        return;
      }
      const xhr = new XMLHttpRequest();
      xhr.open("GET", this.pdfUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          const res = xhr.response;
          const link = document.createElement("a");
          link.style.display = "none";
          const url = window.URL.createObjectURL(res);
          link.href = url;
          const downloadFileName = this.pdfName || "下载文件";
          link.setAttribute("download", downloadFileName);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        } else {
          window.open(this.pdfUrl, "_blank");
        }
      };
      xhr.onerror = () => {
        window.open(this.pdfUrl, "_blank");
      };
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
/* 保持与 pdf/index.vue 100% 一致的外层容器与整体结构 */
.contentBox {
  width: 1400px;
  min-height: 100vh;
  margin: 0 auto;
  margin-top: 30px;
  padding: 40px 0 100px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* 核心内容渲染区容器 */
.preview-body {
  width: 100%;
  height: calc(100vh - 180px);
  min-height: 650px;
  position: relative;
  z-index: 10;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.office-render-container {
  width: 100%;
  height: 100%;
  min-height: 650px;
  position: relative;
  box-sizing: border-box;

  /* 样式穿透：确保 @js-preview/excel 渲染出的内部 Canvas 与 luckysheet 工作区全屏伸展 */
  /deep/ .js-preview-excel,
  /deep/ .luckysheet-workarea,
  /deep/ .luckysheet-share-story,
  /deep/ .luckysheet {
    width: 100% !important;
    height: 100% !important;
  }
}

.image-preview-wrap {
  width: 100%;
  min-height: calc(100vh - 180px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  box-sizing: border-box;
  background: #f8f9fa;
  .preview-img {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
}

.preview-iframe {
  width: 100%;
  height: calc(100vh - 180px);
  border: none;
}

.fallback-preview-wrap {
  width: 100%;
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  color: #606266;
  .fallback-icon {
    font-size: 64px;
    color: #00d8c3;
  }
  .fallback-title {
    font-size: 20px;
    font-weight: 600;
    color: #303133;
    margin: 0;
  }
  .fallback-desc {
    font-size: 14px;
    color: #909399;
    margin: 0 0 16px;
  }
}

/* 底部悬浮控制条（与 pdf/index.vue 相同） */
.btmBox {
  position: fixed;
  width: 100%;
  height: 79px;
  background-color: #fff;
  left: 0;
  bottom: 0;
  z-index: 100000;
  border-top: 1px solid #ebedf0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.btn {
  position: fixed;
  right: 314px;
  bottom: 20px;
  width: 112px;
  height: 38px;
  background: #00d8c3;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
}

.return {
  position: fixed;
  right: 460px;
  bottom: 20px;
  width: 112px;
  height: 38px;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  background: #ffffff;
  transition: border-color 0.2s, color 0.2s;
  &:hover {
    border-color: #00d8c3;
    color: #00d8c3;
  }
}

/* 个人信息倾斜水印 */
.contentBoxText {
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  color: rgba(0, 0, 0, 0.11);
  z-index: 100;
  pointer-events: none;
  background-size: 100% 100%;
  font-size: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-45deg);
}

.contentItem {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
</style>
